/* eslint-disable camelcase */
import { BNPL_LIMIT_MANAGEMENT } from 'constants/routes';
import { createAbsoluteHref } from 'utils/routeUtils';

import { JARABOT_EVENTS } from '../jarabotClient';
import { BnplLimitsOfferProducts } from './types';

export type BnplLimitsOfferPayload = {
	step: typeof JARABOT_EVENTS.CUSTOMER_BNPL_LIMITS_OFFER;
	products: BnplLimitsOfferProducts;
	arrange_url: string;
};

interface BuildBnplLimitsOfferPayloadParams {
	products: BnplLimitsOfferProducts;
	selfCareUrl: string;
}

export function createBnplLimitsOfferPayload({
	products,
	selfCareUrl,
}: BuildBnplLimitsOfferPayloadParams): BnplLimitsOfferPayload {
	return {
		step: JARABOT_EVENTS.CUSTOMER_BNPL_LIMITS_OFFER,
		products,
		arrange_url: createAbsoluteHref(BNPL_LIMIT_MANAGEMENT, selfCareUrl),
	};
}
